import Cookie from 'js-cookie';

interface ICookieOption {
  [key: string]: any;
}

const storage = {
  set(key: string, value: string) {
    window.localStorage.setItem(key, value);
  },
  get(key: string) {
    return window.localStorage.getItem(key);
  },
  /**
   * For sessionStorage
   */
  session: {
    set(key: string, value: string) {
      window.sessionStorage.setItem(key, value);
    },

    get(key: string) {
      return window.sessionStorage.getItem(key);
    },
  },
  /**
   * For cookie
   */
  cookie: {
    set(key: string, value: string, options: ICookieOption) {
      Cookie.set(key, value, options);
    },
    get(key: string) {
      return Cookie.get(key);
    },
    getJSON(key: string) {
      return (Cookie as any).getJSON(key);
    },
  },
};

export default storage;
